/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog, Typography2 } from '@coursera/cds-core';
import { AnswerCorrectIcon, ContextualHelpIcon, WarningIcon } from '@coursera/cds-icons';

import { Button } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-ui';

const { HeadingGroup, Content, Actions } = Dialog;

type Props = {
  onConfirmation: () => void;
  title?: string;
  description: React.ReactNode;
  isWarning?: boolean;
  severity?: 'warning' | 'success' | 'information';
};

const NotificationModal = ({ onConfirmation, title, description, isWarning, severity }: Props) => {
  const iconType = severity ?? (isWarning ? 'warning' : 'success');
  return (
    <Dialog open onClose={onConfirmation}>
      {title && <HeadingGroup>{title}</HeadingGroup>}
      <Content
        css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      >
        {iconType === 'warning' && <WarningIcon size="large" color="warning" css={{ transform: 'scale(3)' }} />}
        {iconType === 'success' && <AnswerCorrectIcon size="large" color="success" css={{ transform: 'scale(3)' }} />}
        {iconType === 'information' && (
          <ContextualHelpIcon size="large" color="support" css={{ transform: 'scale(3)' }} />
        )}
        <Typography2 component="p" variant="bodyPrimary" css={{ marginTop: 64, textAlign: 'center' }}>
          {description}
        </Typography2>
      </Content>
      <Actions css={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant="primary" onClick={onConfirmation}>
          {isWarning ? _t('Continue') : _t('Got it')}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default NotificationModal;
